import React, { Component } from 'react';

export default class Charity extends Component {

    render() {
        return (
            <div>
                <div>
                    <p>No Goods or Services were provided or promised in return for your support, this is not a quid pro quo benefit provided to you. </p>
                </div>
                
            </div>
        );
    }
}